import { COLORS } from "./colors";

export type TableItemType = {
  title: string;
  key: string;
  bgColor: string;
  txColor: string;
};

export interface CommentType {
  id: number;
  userFullName: string;
  content: string;
  createdAt: string;
  updatedAt: string;
  isEdit: boolean;
  isDelete: boolean;
}

export type CommentTypeEnum = "project" | "task" | "selling";

export enum PriorityEnum {
  HIGH = "Високий",
  MEDIUM = "Середній",
  LOW = "Низький",
}

export enum StageEnum {
  NECESSARY = "Необхідно зробити",
  IN_WORKS = "В роботі",
  WAIT_REVIEW = "Очікує на перевірку",
  DONE = "Виконано",
  NOT_DONE = "Не виконано",
}

export const prioritiesObj: Record<PriorityEnum, TableItemType> = {
  [PriorityEnum.LOW]: {
    title: "Низький",
    key: "low",
    bgColor: COLORS.gray,
    txColor: COLORS.blue,
  },
  [PriorityEnum.MEDIUM]: {
    title: "Середній",
    key: "medium",
    bgColor: COLORS.main2,
    txColor: COLORS.secondary1,
  },
  [PriorityEnum.HIGH]: {
    title: "Високий",
    key: "high",
    bgColor: COLORS.warning,
    txColor: COLORS.white,
  },
};

export const stagesObj: Record<StageEnum, TableItemType> = {
  [StageEnum.DONE]: {
    title: "Виконано",
    key: "done",
    bgColor: COLORS["light-green"],
    txColor: COLORS.main1,
  },
  [StageEnum.NOT_DONE]: {
    title: "Не виконано",
    key: "not_done",
    bgColor: COLORS["light-warning"],
    txColor: COLORS.warning,
  },
  [StageEnum.NECESSARY]: {
    title: "Необхідно зробити",
    key: "necessary",
    bgColor: COLORS["light-blue"],
    txColor: COLORS.blue,
  },
  [StageEnum.WAIT_REVIEW]: {
    title: "Очікує на перевірку",
    key: "wait_review",
    bgColor: COLORS["light-bg-color"],
    txColor: COLORS["bg-text-color"],
  },
  [StageEnum.IN_WORKS]: {
    title: "В роботі",
    key: "in_works",
    bgColor: COLORS["light-orange"],
    txColor: COLORS.main2,
  },
};

export interface NameIdType {
  id: string;
  name: string;
}

export enum EndpointsEnum {
  PRIORITY = "priorities",
  STAGE = "stages",
  CURRENCY = "valutas",
  CLIENTS = "contacts/search",
  COMPANIES = "companies/search",
  RESPONSIBLE_USER = "get-users/search",
}

export interface ClientProjectType {
  id: number;
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  company: string;
  clientType: string;
  responsiveContact: string;
}

export interface CompanyProjectType {
  name: string;
  contactUser: string;
}

export interface ProjectMember {
  email: string;
  roleName: string;
  fullName?: string;
  filteredResponsible?: { fullName: string; email: string }[];
}

export interface CurrencyType {
  id: number;
  symbol: string;
  name: string;
}

export const rolesArray = [
  { id: "admin", name: "Адміністратор" },
  { id: "manager", name: "Менеджер" },
  { id: "employee", name: "Співробітник" },
  { id: "support", name: "Служба підтримки" },
  { id: "business-analyst", name: "Аналітик" },
  { id: "developer", name: "Розробник" },
  { id: "sales", name: "Менеджер з продажу" },
  { id: "marketing", name: "Маркетолог" },
];

export enum PeriodTypesEnum {
  WEEK = "week",
  MONTH = "month",
  QUARTER = "quarter",
  YEAR = "year",
  ALLTIME = "alltime",
}

export const periodsObj = {
  [PeriodTypesEnum.WEEK]: {
    text: "Тиждень",
  },
  [PeriodTypesEnum.MONTH]: {
    text: "Місяць",
  },
  [PeriodTypesEnum.QUARTER]: {
    text: "Квартал",
  },
  [PeriodTypesEnum.YEAR]: {
    text: "Рік",
  },
  [PeriodTypesEnum.ALLTIME]: {
    text: "Весь час",
  },
};

export enum TypeClientEnum {
  POTENTIAL_CLIENT = "Потенційний клієнт",
  CURRENT_CUSTOMER = "Діючий клієнт",
  PARTNER = "Партнер",
  LOST_CUSTOMER = "Втрачений клієнт",
}

export const typeClientObj: Record<TypeClientEnum, any> = {
  [TypeClientEnum.POTENTIAL_CLIENT]: {
    title: "Потенційний клієнт",
    bgColor: COLORS.main1,
    txColor: COLORS["light-gray"],
  },
  [TypeClientEnum.CURRENT_CUSTOMER]: {
    title: "Діючий клієнт",
    bgColor: COLORS.main2,
    txColor: COLORS["light-gray"],
  },
  [TypeClientEnum.PARTNER]: {
    title: "Партнер",
    bgColor: COLORS.blue,
    txColor: COLORS["light-gray"],
  },
  [TypeClientEnum.LOST_CUSTOMER]: {
    title: "Втрачений клієнт",
    bgColor: COLORS.warning,
    txColor: COLORS["light-gray"],
  },
}